<div class="country-selector">
  @if (currentCountry(); as current) {
    <button 
      class="country-selector__button"
      type="button"
      [attr.aria-label]="'Skift land'"
      i18n-aria-label>
      <img 
        [src]="current.flagIcon" 
        [alt]="current.countryCode"
        class="country-selector__flag"
        width="20"
        height="20">
      <span class="country-selector__label">{{ current.label }}</span>
    </button>

    @if (otherCountries().length > 0) {
      <div class="country-selector__dropdown">
        @for (country of otherCountries(); track country.locale) {
          <button 
            (click)="switchCountry(country)"
            class="country-selector__option"
            type="button"
            [attr.aria-label]="'Skift til ' + country.label"
            i18n-aria-label>
            <img 
              [src]="country.flagIcon" 
              [alt]="country.countryCode"
              class="country-selector__flag"
              width="20"
              height="20">
            <span class="country-selector__label">{{ country.label }}</span>
          </button>
        }
      </div>
    }
  }
</div>
